module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_search_map-3d4c8ed2e2c0c0c707fd76da36b30552.svg";